import apiCommonCategory from "@/api/common-category";
import {post} from "@/utils/request";

export default class apiBkBookOrder extends apiCommonCategory{
  static module = 'bk_book_order'

  static async submit(title, remark){
    return post('/home/bk_book_order/submit', {title, remark})
  }

  static async cancel(id){
    return post('/home/bk_book_order/cancel', {id})
  }

  static async resume(id){
    return post('/home/bk_book_order/resume', {id})
  }

  static async customerExport(id){
    return post('/home/bk_book_order/customerExport', {id})
  }

  static async del(id){
    return post('/home/bk_book_order/del', {id})
  }
}
